import { createContext, useContext, useEffect, useState } from 'react';
import { PublicGetAgent, type PublicAgent } from '@magic/schemas/agents';
import { useParams } from 'react-router-dom';

import { request } from '../request';

const AgentContext = createContext<PublicAgent>(undefined!);

export const useAgent = () => {
  return useContext(AgentContext);
};

export const AgentProvider = ({ children }: { children: React.ReactNode }) => {
  const params = useParams<PublicGetAgent>();
  const [agent, setAgent] = useState<PublicAgent>(null!);

  useEffect(() => {
    const load = async () => {
      try {
        const response: PublicAgent = await request({
          method: 'GET',
          api: `${import.meta.env.VITE_CHAT_API_URL}assistants/${
            params.workspaceId
          }/${params.id}`,
        });
        setAgent(response);
      } catch (e) {
        console.error(e);
      }
    };

    load();
  }, [params.id, params.workspaceId, setAgent]);

  return (
    <AgentContext.Provider value={agent}>{children}</AgentContext.Provider>
  );
};
